export default "__VITE_ASSET__D3C1CPm9__"